import { useLocalStorage } from 'usehooks-ts'

export type DistanceMeasurement = 'km' | 'miles'

function useDistanceMeasurement() {
  return useLocalStorage<DistanceMeasurement>('settings.measurement.distance', 'km')
}

export default useDistanceMeasurement
